var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 22h-.3A21 21 0 0 1 0 3.3C0 2.4.2 1.6.8 1 1.4.4 2.2 0 3 0h3a3 3 0 0 1 3 2.6c.1.9.3 1.8.7 2.6.4 1.1.1 2.3-.7 3.2l-.7.7c1.2 1.9 2.8 3.4 4.6 4.6l.7-.7c.8-.8 2.1-1.1 3.2-.7.8.3 1.7.5 2.6.6a3 3 0 0 1 2.6 3v3a3 3 0 0 1-1 2.2c-.5.6-1.3.9-2 .9zM6 2H3a1 1 0 0 0-.7.3c-.2.2-.3.5-.3.8.3 2.9 1.3 5.8 3 8.2a18.7 18.7 0 0 0 14 8.6l.7-.3c.3-.2.3-.3.3-.6v-3c0-.5-.4-1-.9-1-1-.1-2.1-.4-3-.8-.4-.1-.8 0-1 .2l-1.4 1.3a1 1 0 0 1-1.2.2 16.4 16.4 0 0 1-6.4-6.4c-.2-.5 0-1 .2-1.3L7.6 7c.3-.3.4-.7.2-1.1-.4-1-.6-2-.8-3 0-.5-.5-.9-1-.9z",
    fill: "currentColor"
  })));
};
export default SvgPhone;